// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ResearcherProvider } from './context/ResearcherContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ResearcherProvider>
      <App />
    </ResearcherProvider>
  </React.StrictMode>
);

reportWebVitals();
